import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    Building2,
    Home,
    Wrench,
    Anchor,
    Heart,
    Briefcase,
    Wallet,
    Radio,
    Leaf,
    Camera,
    Users,
    GraduationCap,
    Search,
    Sparkles
} from 'lucide-react';

function Bidang() {
    const [searchTerm, setSearchTerm] = useState('');
    const [hoveredIndex, setHoveredIndex] = useState(null);

    const bidangData = [
        { id: 'bumd', name: 'BUMD', icon: Building2, image: 'https://bo.jdih.magelangkota.go.id/banner/bumd2.png', color: 'from-blue-500 to-blue-600' },
        { id: 'desa', name: 'Desa', icon: Home, image: 'https://bo.jdih.magelangkota.go.id/banner/desa.png', color: 'from-green-500 to-green-600' },
        { id: 'infrastruktur', name: 'Infrastruktur', icon: Wrench, image: 'https://bo.jdih.magelangkota.go.id/banner/infra.png', color: 'from-orange-500 to-orange-600' },
        { id: 'kelautan', name: 'Kelautan', icon: Anchor, image: 'https://bo.jdih.magelangkota.go.id/banner/kedaulatan.png', color: 'from-cyan-500 to-cyan-600' },
        { id: 'kesehatan', name: 'Kesehatan', icon: Heart, image: 'https://bo.jdih.magelangkota.go.id/banner/kesehatan.png', color: 'from-red-500 to-red-600' },
        { id: 'ketenagakerjaan', name: 'Ketenagakerjaan', icon: Briefcase, image: 'https://bo.jdih.magelangkota.go.id/banner/ketenagakerjaan.png', color: 'from-purple-500 to-purple-600' },
        { id: 'keuangan', name: 'Keuangan', icon: Wallet, image: 'https://bo.jdih.magelangkota.go.id/banner/keuangan.png', color: 'from-emerald-500 to-emerald-600' },
        { id: 'komunikasi', name: 'Komunikasi', icon: Radio, image: 'https://bo.jdih.magelangkota.go.id/banner/komunikasi.png', color: 'from-indigo-500 to-indigo-600' },
        { id: 'lingkungan', name: 'Lingkungan', icon: Leaf, image: 'https://bo.jdih.magelangkota.go.id/banner/lingkungan.png', color: 'from-teal-500 to-teal-600' },
        { id: 'pariwisata', name: 'Pariwisata', icon: Camera, image: 'https://bo.jdih.magelangkota.go.id/banner/pariwisata.png', color: 'from-yellow-500 to-yellow-600' },
        { id: 'pemerintahan', name: 'Pemerintahan', icon: Users, image: 'https://bo.jdih.magelangkota.go.id/banner/pemerintahan.png', color: 'from-slate-500 to-slate-600' },
        { id: 'pendidikan', name: 'Pendidikan', icon: GraduationCap, image: 'https://bo.jdih.magelangkota.go.id/banner/pendidikan.png', color: 'from-violet-500 to-violet-600' },
    ];

    const filteredBidang = bidangData.filter(item =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="w-full bg-gradient-to-br from-blue-50 via-white to-purple-50 py-12 px-4">
            <div className="max-w-7xl mx-auto">
                {/* Header Section */}
                <div className="text-center mb-10">
                    <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-[#0889c1]/10 to-purple-500/10 rounded-full mb-4">
                        <Sparkles className="w-4 h-4 text-[#0889c1]" />
                        <span className="text-xs font-medium text-gray-600">JDIH Kota Magelang</span>
                    </div>

                    <h1 className="text-4xl md:text-5xl font-bold mb-3" style={{ fontFamily: 'MuseoSansRounded900' }}>
                        <span className="text-[#0889c1]">Bidang</span>
                        <span className="text-gray-700"> Hukum</span>
                    </h1>

                    <div className="w-24 h-1 bg-gradient-to-r from-[#0889c1] to-purple-500 mx-auto rounded-full"></div>

                    <p className="mt-4 text-gray-600 text-sm md:text-base max-w-2xl mx-auto">
                        Daftar bidang yang berkaitan dengan produk hukum di Kota Magelang
                    </p>
                </div>

                {/* Bidang Grid */}
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-6">
                    {filteredBidang.length > 0 ? (
                        filteredBidang.map((item, index) => {
                            const Icon = item.icon;
                            return (
                                <a
                                    key={item.id}
                                    href={`#/${item.id}`}
                                    onMouseEnter={() => setHoveredIndex(index)}
                                    onMouseLeave={() => setHoveredIndex(null)}
                                    className="group relative flex flex-col items-center p-4 md:p-6 bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 hover:scale-105"
                                >
                                    {/* Gradient Border */}
                                    <div className="absolute inset-0 bg-gradient-to-r from-[#0889c1] to-purple-500 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"></div>
                                    <div className="relative bg-white rounded-2xl p-4 md:p-6 w-full flex flex-col items-center">

                                        {/* Icon Badge */}
                                        <div className="absolute -top-2 -right-2 bg-gradient-to-r from-[#0889c1] to-purple-500 rounded-full p-1.5 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                            <Icon className="w-3 h-3 text-white" />
                                        </div>

                                        {/* Image Container */}
                                        <div className="relative w-full h-20 md:h-24 flex items-center justify-center mb-3">
                                            <img
                                                src={item.image}
                                                alt={item.name}
                                                className="max-h-full max-w-full object-contain transition-transform duration-500 group-hover:scale-110"
                                                loading="lazy"
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = `data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="100" height="100"%3E%3Crect width="100" height="100" fill="%23e5e7eb"/%3E%3Ctext x="50" y="55" font-family="Arial" font-size="14" fill="%236b7280" text-anchor="middle"%3E${item.name}%3C/text%3E%3C/svg%3E`;
                                                }}
                                            />

                                            {/* Hover Overlay */}
                                            <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg"></div>
                                        </div>

                                        {/* Name */}
                                        <p className="text-sm md:text-base font-semibold text-gray-800 group-hover:text-[#0889c1] transition-colors duration-200 text-center">
                                            {item.name}
                                        </p>

                                        {/* Decorative Line */}
                                        <div className="mt-2 w-8 h-0.5 bg-gradient-to-r from-[#0889c1] to-purple-500 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                    </div>
                                </a>
                            );
                        })
                    ) : (
                        <div className="col-span-full text-center py-16 bg-white rounded-2xl shadow-lg">
                            <Search className="w-20 h-20 text-gray-300 mx-auto mb-4" />
                            <h3 className="text-xl font-bold text-gray-700 mb-2">Bidang Tidak Ditemukan</h3>
                            <p className="text-gray-500">Tidak ada bidang yang sesuai dengan pencarian Anda</p>
                        </div>
                    )}
                </div>

                {/* Footer Info */}
               
            </div>
        </div>
    );
}

export default Bidang;